"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HelpSidebarDrawer;
var _reactIntl = require("react-intl");
var _Drawer = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Drawer"));
var _useMediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/hooks/useMediaQuery"));
var _defaultTheme = _interopRequireDefault(require("@kiwicom/orbit-components/lib/defaultTheme"));
var _context = require("@kiwicom/nitro/lib/services/intl/context");
var _constants = require("./utils/constants");
var _utilities = require("./utils/utilities");
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/builds/frontend/smart-faq/packages/smart-faq-sidebar/src/app/HelpSidebarDrawer.tsx";
function HelpSidebarDrawer(_ref) {
  let {
    children,
    isShown,
    onClose
  } = _ref;
  const {
    isTablet
  } = (0, _useMediaQuery.default)();
  const {
    language
  } = (0, _context.useIntl)();
  return (0, _jsxRuntime.jsx)(_Drawer.default, {
    dataTest: _constants.SidebarCypressTestAttribute.DRAWER_CONTAINER,
    shown: isShown,
    fixedHeader: true,
    position: language.direction === _constants.LanguageDirection.RTL ? 'left' : 'right',
    suppressed: true,
    noPadding: true,
    title: (0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "smartfaq.header.title",
      defaultMessage: "Help"
    }),
    width: isTablet ? `${_defaultTheme.default.orbit.widthBreakpointLargeMobile}px` : '100%',
    ...((0, _utilities.isWebview)() || !onClose ? {} : {
      onClose
    }),
    children: children
  });
}